<div class="custom-filter-area">
    <div class="filters-area">
        <span class="title-txt">Customize Columns</span>
        <span class="cls-btn" (click)="onCloseBtn()"><mat-icon>close</mat-icon></span>
    </div>

    <div class="hr"></div>
    <div class="list-box">
        <input type="checkbox" id="all" name="all" [checked]="allSelected" (change)="selectAll()">
        <label class="list-name" style="font-weight: 700;cursor: pointer;padding: 10px;"
            (click)="onSortingColumns()">Column Name
            <mat-icon>sync_alt</mat-icon>
        </label>
    </div>

    <div cdkDropList class="drag-list-area" (cdkDropListDropped)="drop($event)">
        @for (i of listArr; track i) {
            @if(i.name !== "Selected" || i.name !== "action"){
            <div class="list-box" cdkDrag>
                <input type="checkbox" id={{i.name}} name={{i.name}} [checked]="i.selected"
                (change)="selectItem(i.name)">
            <label class="list-name" for={{i.name}}>{{i.label}}</label>
        </div>
         }
        }
    </div>
    
    <div class="hr"></div>
    <div class="right-area">
        <button class="white-red-btn" (click)="onCloseBtn()">Cancel</button>
        <button class="red-white-btn" (click)="onSaveBtn()">Save</button>
    </div>
</div>